const comments = [
  {
    id: 1,
    name: '吃瓜群众甲',
    avatar: 'A',
    time: '2小时前',
    content: '这个网站真的太敢了！好多料在外面根本看不到，而且每件事都有时间线和证据链，不是那种捕风捉影的地摊文学。关注了快半年了，信息更新确实快。',
    likes: 1892,
    tag: '老用户',
  },
  {
    id: 2,
    name: '匿名网友9527',
    avatar: '匿',
    time: '5小时前',
    content: '之前那个综艺黑幕的爆料就是在这里首发看到的，当时还半信半疑，结果三天后全网都炸了。信息源确实硬，建议长期关注的吃瓜朋友们收藏起来。',
    likes: 2341,
    tag: '铁粉',
  },
  {
    id: 3,
    name: '资深娱记小李',
    avatar: '李',
    time: '8小时前',
    content: '作为从业者说句公道话，911爆料网的信息整理能力在同类平台里面算顶尖的。事件梳理清晰，不添油加醋，也不站队带节奏，在现在的网络环境下很难得。',
    likes: 3156,
    tag: '业内人士',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="section-anchor py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">吃瓜群众热议</h2>
          <p className="text-sm text-foreground-500 max-w-[600px] mx-auto">来自真实用户的评价，看看大家怎么说</p>
        </div>

        <div className="space-y-4">
          {comments.map((item) => (
            <div key={item.id} className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                  <span className="text-sm font-bold text-primary-700">{item.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="text-sm font-semibold text-foreground-800">{item.name}</span>
                    <span className="px-1.5 py-0.5 bg-accent-100 text-accent-800 text-xs rounded">{item.tag}</span>
                    <span className="text-xs text-foreground-500">{item.time}</span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3">{item.content}</p>
                  <div className="flex items-center gap-4 text-xs text-foreground-500">
                    <span className="flex items-center gap-1 cursor-pointer hover:text-primary-600 transition-colors">
                      <i className="ri-thumb-up-line"></i> {item.likes.toLocaleString()}
                    </span>
                    <span className="flex items-center gap-1 cursor-pointer hover:text-primary-600 transition-colors">
                      <i className="ri-chat-1-line"></i> 回复
                    </span>
                    <span className="flex items-center gap-1 cursor-pointer hover:text-primary-600 transition-colors">
                      <i className="ri-share-forward-line"></i> 分享
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}